export const estimateCostsText =
  'Quickly estimate the cost of common services and procedures based on your location and plan coverage by browsing your available services.';

export const insuranceNotFoundText =
  'Sorry, we’re having trouble locating your insurance information. Please try again later.';
